module.exports = __webpack_public_path__ + "img/FATIMA NECKLACE RED.250ffd9.svg";